import { z } from "zod";
import { VALIDATION_MESSAGES_CARD } from "constants/validations";

/**
 * Validates and filters feet input (3-7 range)
 */
export const filterFeet = (value: string): string => {
    const numericValue = value.replace(/\D/g, "");
    if (numericValue === "") return "";
    const num = parseInt(numericValue);
    return num >= 3 && num <= 7 ? numericValue : "";
};

/**
 * Validates and filters inches input (0-11 range)
 */
export const filterInches = (value: string): string => {
    const numericValue = value.replace(/\D/g, "");
    if (numericValue === "") return "";
    return parseInt(numericValue) <= 11 ? numericValue : "";
};

// Height Schema
export const heightSchema = z
    .object({
        feet: z
            .string()
            .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
            .refine(
                (val) => {
                    const num = parseInt(val, 10);
                    return !isNaN(num) && num >= 3 && num <= 7;
                },
                { message: "Height must be between 3 and 7 feet" }
            ),
        inches: z
            .string()
            .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
            .refine(
                (val) => {
                    const num = parseInt(val, 10);
                    return !isNaN(num) && num >= 0 && num <= 11;
                },
                { message: "Inches must be between 0 and 11" }
            ),
    })
    .refine(
        (data) => {
            const feet = parseInt(data.feet, 10);
            const inches = parseInt(data.inches, 10);
            // Ensure minimum height is 3'0" and maximum is 7'11"
            return !isNaN(feet) && !isNaN(inches);
        },
        { message: "Please enter a valid height" }
    );

export const optionalHeightSchema = z
    .object({
        feet: z.string().optional(),
        inches: z.string().optional(),
    })
    .optional();
